import React, { useEffect, useState } from "react";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { DatePicker, Select, Space } from "antd";
import moment from "moment";
import { InputBox } from "../CustomWidgets/InputBox";
import SelectBox from "../CustomWidgets/SelectBox";
import { useSelector } from "react-redux";
import { useFormik } from "formik";
import { addExpenseSchema } from "../validationSchema";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { toast } from "react-toastify";
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 999,
  },
  container: {
    width: "30%",
    padding: "30px",
    paddingTop: "20px",
    borderRadius: "18px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontSize: "20px",
    fontWeight: "bold",
    textAlign: "left",
    marginBottom: "10px",
  },
  cancelIcon: {
    cursor: "pointer",
  },
  description: {
    textAlign: "left",
    fontSize: "16px",
    color: "#272728",
    marginTop: "10px",
  },
  input: {
    width: "100%",
    padding: "10px",
    borderRadius: "12px",
    border: "1px solid #CCCCCC",
    marginBottom: "20px",
    boxSizing: "border-box",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
  },
  button: {
    width: "180px",
    height: "45px",
    borderRadius: "5px",
    border: "none",
    cursor: "pointer",
    marginRight: "10px",
    transition: "opacity 0.3s", // Smooth transition for opacity change
  },
  confirmButton: {
    backgroundColor: "primaryBlue",
    color: "#FFFFFF",
  },
  cancelButton: {
    backgroundColor: "#CCCCCC",
    color: "#000000",
  },
};
const AddNewExpense = ({ isOpen, onClose, userData, ExpenseUpdated }) => {
  const [fields, setFields] = useState([]);
  const { t, i18n } = useTranslation();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const { RangePicker } = DatePicker;
  const { Option } = Select;
  const [selectedUser, setSelectedUser] = useState(null);
  const [transactionType, setTransactionType] = useState(null);
  const company_name = useSelector(
    (state) => state?.login?.user?.result?.company_name
  );
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const [loading, setLoading] = useState(false);
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);

  const formik = useFormik({
    initialValues: {
      amount: "",
      transaction_type: "",
      user: "",
      description: "",
    },
    validationSchema: addExpenseSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      AddExpense(values);
    },
  });

  const AddExpense = async (values) => {
    try {
      const response = await axiosInstance.post(URLS.TRANSACTION_ENTRY, {
        user_id: selectedUser ? selectedUser : user_id,
        company_id: company_id,
        amount: Number(values.amount),
        description: values?.description,
        source: "Expense Module",
        transaction_type: values?.transaction_type,
      });
      if (response?.data?.result?.status_code == 200) {
        toast.success(t("Expense Updated Successfully"));
        ExpenseUpdated();
      } else {
        toast.error(t(response?.data?.result?.statu));
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setLoading(false);
    }
  };

  const handleOptionChange = (selectedValue) => {
    if (selectedValue === company_name) {
      setSelectedUser(null); // Reset selected category
      formik.setFieldValue("user", company_name);
    } else {
      setSelectedUser(selectedValue);
      formik.setFieldValue("user", selectedValue);
    }
  };

  const handleSelectTransactionType = (e) => {
    setTransactionType(e.target.value);
    formik.setFieldValue("transaction_type", e.target.value);
  };

  return (
    isOpen && (
      <>
        <div
          className="backdrop-blur"
          style={styles.overlay}
          onClick={onClose}
        ></div>
        <div style={styles.container}>
          <div style={styles.header}>
            <p style={styles.title}>{t("Add Cash In/Out")}</p>
            <CloseOutlined style={styles.cancelIcon} onClick={onClose} />
          </div>
          <form onSubmit={formik.handleSubmit}>
            <span className="w-[30%]">
              <InputBox
                label={t("Amount")}
                placeholder={t("e.g EGP 100")}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.amount}
                error={formik.errors.amount}
                touched={formik.touched.amount}
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d{0,7}$/.test(val) || val === "") {
                    formik.setFieldValue("amount", val);
                  }
                }}
              />
            </span>
            <SelectBox
              label={t("Cash In/Cash Out")}
              error={formik.errors.transaction_type}
              touched={formik.touched.transaction_type}
              //  componentWidth={"w-56"}
              value={transactionType}
              options={[
                { value: "cash_in", name: "Cash In", label: t("Cash In") },
                { value: "cash_out", name: "Cash Out", label: t("Cash Out") },
              ]}
              onChange={handleSelectTransactionType}
              placeholder={t("Enter Transaction Type")}
            />
            <div className="mt-3">
              <label className=" py-2 text-sm text-gray-600 font-medium">
                {t("User")}
              </label>
              <Select
                className="overflow-hidden"
                style={{
                  width: "100%",
                  // width: 200,
                  // minWidth: 200,
                  height: 40,
                }}
                placeholder={t("Select User")}
                value={selectedUser || company_name} // Set default value to "All Categories"
                onChange={handleOptionChange} // Keep this as is
              >
                <Option value={user_id}>{t(company_name)}</Option>{" "}
                {/* Add All Categories option */}
                {Object.values(userData)?.map((option) => (
                  <Option key={option.user_id} value={option.user_id}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </div>
            <span className="w-[30%]">
              <InputBox
                label={t("Description")}
                placeholder={t("e.g Cleaning Supplies")}
                value={formik.values.description}
                error={formik.errors.description}
                touched={formik.touched.description}
                onChange={(e) => {
                  const val = e.target.value;
                  formik.setFieldValue("description", val);
                }}
                // onBlur={formik.handleBlur}
              />
            </span>

            {/* Action Buttons */}
            <div className="flex justify-end gap-4 mt-5 ">
              <button
                type="button"
                onClick={onClose}
                className="w-32 px-2 py-2 border border-gray-300 font-semibold rounded-lg text-gray-700 hover:bg-gray-50"
              >
                {t("Cancel")}
              </button>
              <button
                type="submit"
                //   disabled={startDate == "" || endDate == ""}
                className={`w-32 px-2 py-2 rounded-lg font-semibold text-white  bg-primaryBlue`}
                // className="w-full px-4 py-2 bg-primaryBlue text-white rounded-lg hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {t("Save")}
              </button>
            </div>
          </form>
        </div>
      </>
    )
  );
};

export default AddNewExpense;
